import BaseCRUDService from './BaseCRUDService';
import { ajax } from '../helpers/ajax';
import AuthService from './AuthService';

class TherapyService extends BaseCRUDService {
  getBaseURL = () => {
    return '~/api/therapy';
  };

  getListPatient(id, page, pageSize, searchText, sortColumn, sortDirection) {
    return new Promise((resolve, reject) => {
      ajax({
        url: `~/api/therapy/patient/${id}`,
        type: 'GET',
        headers: { 'x-access-token': AuthService.getToken() },
        data: {
          page,
          pageSize,
          searchText,
          sortColumn,
          sortDirection,
        },
        success: (data, textStatus, jqXHR) => {
          resolve(data);
        },
        error: (jqXHR, textStatus, errorThrown, errorMessage) => {
          reject(errorThrown);
        },
        complete: () => {},
      });
    });
  }

  getListUser(id) {
    return new Promise((resolve, reject) => {
      ajax({
        url: `~/api/therapy/user/${id}`,
        type: 'GET',
        headers: { 'x-access-token': AuthService.getToken() },
        success: (data, textStatus, jqXHR) => {
          resolve(data);
        },
        error: (jqXHR, textStatus, errorThrown, errorMessage) => {
          reject(errorThrown);
        },
        complete: () => {},
      });
    });
  }

  getListEquipment(id, page, pageSize, searchText, sortColumn, sortDirection) {
    return new Promise((resolve, reject) => {
      ajax({
        url: `~/api/therapy/equipment/${id}`,
        type: 'GET',
        headers: { 'x-access-token': AuthService.getToken() },
        data: {
          page,
          pageSize,
          searchText,
          sortColumn,
          sortDirection,
        },
        success: (data, textStatus, jqXHR) => {
          resolve(data);
        },
        error: (jqXHR, textStatus, errorThrown, errorMessage) => {
          reject(errorThrown);
        },
        complete: () => {},
      });
    });
  }

  getListContract(id) {
    return new Promise((resolve, reject) => {
      ajax({
        url: `~/api/therapy/contract/${id}`,
        type: 'GET',
        headers: { 'x-access-token': AuthService.getToken() },
        success: (data, textStatus, jqXHR) => {
          resolve(data);
        },
        error: (jqXHR, textStatus, errorThrown, errorMessage) => {
          reject(errorThrown);
        },
        complete: () => {},
      });
    });
  }

  getListEquipmentAll(page, pageSize, searchText, sortColumn, sortDirection) {
    return new Promise((resolve, reject) => {
      ajax({
        url: `~/api/therapy/equipment-all`,
        type: 'GET',
        headers: { 'x-access-token': AuthService.getToken() },
        data: {
          page,
          pageSize,
          searchText,
          sortColumn,
          sortDirection,
        },
        success: (data, textStatus, jqXHR) => {
          resolve(data);
        },
        error: (jqXHR, textStatus, errorThrown, errorMessage) => {
          reject(errorThrown);
        },
        complete: () => {},
      });
    });
  }

  getListEquipmentPacientAll(page, pageSize, searchText, sortColumn, sortDirection) {
    return new Promise((resolve, reject) => {
      ajax({
        url: `~/api/therapy/equipment-patient-all`,
        type: 'GET',
        headers: { 'x-access-token': AuthService.getToken() },
        data: {
          page,
          pageSize,
          searchText,
          sortColumn,
          sortDirection,
        },
        success: (data, textStatus, jqXHR) => {
          resolve(data);
        },
        error: (jqXHR, textStatus, errorThrown, errorMessage) => {
          reject(errorThrown);
        },
        complete: () => {},
      });
    });
  }

  getReport(id, firstDate = '', lastDate = '') {
    return new Promise((resolve, reject) => {
      ajax({
        url: `~/api/report/therapy/${id}`,
        type: 'GET',
        data: { firstDate: firstDate, lastDate: lastDate },
        headers: { 'x-access-token': AuthService.getToken() },
        success: (data, textStatus, jqXHR) => {
          resolve(data);
        },
        error: (jqXHR, textStatus, errorThrown, errorMessage) => {
          reject(errorThrown);
        },
        complete: () => {},
      });
    });
  }
}

export default new TherapyService();
